"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.revisitFormToPayloadDataHandler = revisitFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function revisitFormToPayloadDataHandler(data) {
    var _a, _b, _c, _d, _e, _f, _g;
    const now = (0, dayjs_1.default)();
    return Object.assign(Object.assign({}, (((_a = data === null || data === void 0 ? void 0 : data.clinicianAppointment) === null || _a === void 0 ? void 0 : _a.isConflictAllowed) && {
        isConflictAllowed: true,
    })), { form: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ visitDate: data.visitDate }, (((_b = data.clinicianAppointment) === null || _b === void 0 ? void 0 : _b.visitDate) && {
            nextVisitDate: (_c = data.clinicianAppointment) === null || _c === void 0 ? void 0 : _c.visitDate,
        })), (((_d = data.clinicianAppointment) === null || _d === void 0 ? void 0 : _d.visitStartTime) && {
            nextVisitStartTime: (_e = data.clinicianAppointment) === null || _e === void 0 ? void 0 : _e.visitStartTime,
        })), (((_f = data.clinicianAppointment) === null || _f === void 0 ? void 0 : _f.visitEndTime) && {
            nextVisitEndTime: (_g = data.clinicianAppointment) === null || _g === void 0 ? void 0 : _g.visitEndTime,
        })), (data.notes && { notes: data.notes })), { offSet: now.utcOffset() }) });
}
